import * as React from 'react'

import { WeekRecompenseModel } from 'app/models/weekRecompenseModel'

import { useScene } from '../context/SceneContext'

const color = '#7280FF'

export type WeekRecompenseBlockProps = {
  weekRecompense: WeekRecompenseModel
  index: number
}

const prepareTooltipInfo = (
  weekRecompense: WeekRecompenseModel,
): WeekRecompenseModel => {
  const info: WeekRecompenseModel = {
    ...weekRecompense,
    typeName: 'eventName.weekRecompense',
    color: color,
  }
  return info
}

export const WeekRecompenseBlock: React.FC<WeekRecompenseBlockProps> = React.memo(
  (props: WeekRecompenseBlockProps) => {
    const scene = useScene()

    const weekRecompense = props.weekRecompense

    const width = scene.widthOf(
      weekRecompense.startTime,
      weekRecompense.realRestEndTime,
    )
    if (width <= 0) {
      return null
    }

    const left = scene.timeToX(weekRecompense.startTime)

    return (
      <div
        className="tw-flex tw-flex-col tw-items-start tw-justify-end"
        style={{
          left,
          top: 0,
          bottom: 0,
          position: 'absolute',
        
          paddingBottom: scene.bottomPadding,
        }}
      >
        <div
          style={{
            background: color,
            borderColor: '#000000',
            pointerEvents: 'auto',
            width,
            height: 6,
            borderTopLeftRadius: 3,
            borderTopRightRadius: 3,
          }}
          data-tip={JSON.stringify(prepareTooltipInfo(weekRecompense))}
          data-for="weekRecompenseTooltip"
        />
      </div>
    )
  },
)

WeekRecompenseBlock.displayName = 'WeekRecompenseBlock'
